import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { setMiniSidenav, useMaterialUIController } from "./context";
import { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import routes from "./routes";
import logo from "../src/assest/images/logo.png";
import "./css/app.css";
import LodingCirlce from "./components/Loading/Loding";
import { useLoading } from "./context/LodingContext";
import SignIn from "./meefood/pages/authentication/signin/SignIn";
import EmailForgotInput from "./meefood/pages/authentication/forgot/EmailForgot";
import SetPassword from "./meefood/pages/authentication/setPassword/SetPassword";
import { useAuthData } from "./meefood/context/loginContext/LoginContextProvider";
import Page from "./meefood/pages/privacyPolicy/pages";

function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  const { authenticated, access } = useAuthData();
  const { circleLoading } = useLoading();

  const effectiveAccess =
    access && access.length > 0
      ? access
      : JSON.parse(localStorage.getItem("access") || "[]");

  const checkAccess = (route) => {
    if (route?.module === "All" || !route?.protected) {
      return true;
    }
    return effectiveAccess?.some(
      (entry) =>
        entry?.module === route?.module &&
        (route?.protected === true ? entry?.can_access === true : true),
    );
  };

  const filterRoutes = (routesList) => {
    return routesList
      .map((route) => {
        if (route.collapse && Array.isArray(route.collapse)) {
          const filteredCollapse = filterRoutes(route.collapse);

          if (filteredCollapse.length > 0) {
            return {
              ...route,
              collapse: filteredCollapse,
            };
          }

          // If no child collapse items are accessible:
          // If it has its own route and access is allowed, keep it without collapse
          if (route.route && checkAccess(route)) {
            const { collapse, ...rest } = route;
            return rest;
          }

          return null;
        }

        // Single route without collapse
        return checkAccess(route) ? route : null;
      })
      .filter(Boolean);
  };

  const filteredRoutes = filterRoutes(routes);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <>
            {authenticated && (
              <Route
                exact
                path={route.route}
                element={route.component}
                key={route.key}
              />
            )}
          </>
        );
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {layout === "dashboard" && pathname !== "/privacy-policy" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={logo}
            brandName="Keelis"
            routes={filteredRoutes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
        </>
      )}
      {circleLoading && (
        <div style={{ position: "fixed", inset: 0, zIndex: "1000000000000" }}>
          <LodingCirlce pending={circleLoading} />
        </div>
      )}

      <Routes>
        {getRoutes(filteredRoutes)}

        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/privacy-policy" element={<Page />} />
        <Route path="/sign-in/forgotemail" element={<EmailForgotInput />} />

        <Route path="/set-password/:uid/:token/" element={<SetPassword />} />
        <Route path="/createpassword/:uid/:token/" element={<SetPassword />} />

        <Route
          path="*"
          element={<Navigate to={authenticated ? "/dashboard" : "/sign-in"} />}
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
